import { defineField, defineType } from "sanity";

export const establishCareStepSettingsType = defineType({
  type: "document",
  name: "establishCareStepSettings",
  title: "Establish Care Step Settings",
  groups: [
    { name: "platform", title: "Platform" },
    { name: "env", title: "Env" },
    { name: "build-target", title: "Build Target" }
  ],
  fields: [
    defineField({
      name: "careTeamMembers",
      description:
        "List of Care Team Members who will be displayed on Establish Care Step, in order of displaying",
      title: "Care Team Members",
      type: "array",
      of: [{ type: "reference", to: [{ type: "careTeam" }] }]
    })
  ]
});
